import { render, staticRenderFns } from "./OfferList.vue?vue&type=template&id=bbece9ea&scoped=true&"
import script from "./OfferList.vue?vue&type=script&lang=js&"
export * from "./OfferList.vue?vue&type=script&lang=js&"
import style0 from "./OfferList.vue?vue&type=style&index=0&id=bbece9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbece9ea",
  null
  
)

export default component.exports